/**
 * 'R' : Réparable
 * | 'NR' : Non réparable
 * | 'NA' : Non disponible
 */
export type XOperationType = 'R' | 'NR' | 'NA';

/**
 * 'O' : Ouvert
 * | 'C' : Fermé
 * | 'EC' : Exceptionnellement fermé
 */
export type XStatus = 'O' | 'C' | 'EC';

/**
 * 'WS' : Pare-brise
 * 'RW' : Lunette arrière
 * 'SWLDF' : Vitre portière avant gauche
 * 'SWLDR' : Vitre portière arrière gauche
 * 'SWLCF'	Custode avant gauche
 * 'SWLCR'	Custode arrière gauche
 * 'SWLO' : Autre vitrage latérale gauche
 * 'SWRDF' : Vitre portière avant droite
 * 'SWRDR' : Vitre portière arrière droite
 * 'SWRCF'	Custode avant droite
 * 'SWRCR'	Custode arrière droite
 * 'SWRO' : Autre vitrage latérale droite
 * 'FLL' : Optique avant gauche (Front Light Left)
 * 'FLR' : Optique avant droite (Front Light Right)
 * 'BLL' : Optique arrière gauche (Back Light Left)
 * 'BLR' : Optique arrière droite (Back Light Right)
 * 'ML' : Rétroviseur gauche (Mirror Left)
 * 'MR' : Rétroviseur gauche (Mirror Left)
 * 'RG' : Vitre de toit (Roof Glass)
 */
export type XWindows =
  | 'WS'
  | 'RW'
  | 'SWLDF'
  | 'SWLDR'
  | 'SWLCF'
  | 'SWLCR'
  | 'SWLO'
  | 'SWRDF'
  | 'SWRDR'
  | 'SWRCF'
  | 'SWRCR'
  | 'SWRO'
  | 'FLL'
  | 'FLR'
  | 'BLL'
  | 'BLR'
  | 'ML'
  | 'MR'
  | 'RG'
  | '';

/**
 * 'B' : Cassé
 * | 'C' : Fissure
 * | 'I' : Impact
 * | 'N/A' : Non disponible
 */
export type XDamage = 'B' | 'C' | 'I' | 'N/A';

/**
 * 'B' : Plus grand qu'une pièce de 2 Euros
 * | 'S' : Plus petit qu'une pièce de 2 Euros
 * | 'U' : Ne sais pas
 */
export type XImpactSize = '' | 'B' | 'S' | 'U';
